import AIRolePlayEditor from './AIRolePlayEditor';

export default AIRolePlayEditor;
